import { Fragment } from 'react';

export const OpenInAppGuard = Fragment;
